import { type formPinModeType, pinValidation } from 'BreetHelpers';
import * as yup from 'yup';

export const CreatePinSchema = yup.object().shape({
	pin: pinValidation,
	confirmPin: yup
		.string()
		.required('Confirm PIN is required')
		.oneOf([yup.ref('pin')], 'Pins must match'),
});

export const UpdatePinSchema = yup.object().shape({
	pin: pinValidation,
	oldPin: pinValidation,
});

export type CreatePinSchemaType = yup.InferType<typeof CreatePinSchema>;
export type UpdatePinSchemaType = yup.InferType<typeof UpdatePinSchema>;

export interface IFormPin {
	onSuccess?: () => void;
	mode: formPinModeType;
	otp?: string;
}

export const formPinPageProps: Record<
	formPinModeType,
	{ title: string; description: string; label1: string; label2: string; buttonTitle: string; successMessage: string }
> = {
	create: {
		title: 'Set Transaction PIN',
		description: 'Your PIN secures your account and will be required for all transactions and do not share.',
		label1: 'Create PIN',
		label2: 'Just to be sure, re-enter your PIN',
		buttonTitle: 'Set PIN',
		successMessage: 'PIN created successfully',
	},
	update: {
		title: 'Change Transaction PIN',
		description: 'Your PIN secures your account. This will be required for all transactions and do not share.',
		label1: 'Enter your old PIN',
		label2: 'Enter your new PIN',
		buttonTitle: 'Save PIN',
		successMessage: 'PIN updated successfully',
	},
	reset: {
		title: 'Just one last step',
		description: 'Enter your new transaction PIN.',
		label1: 'Create New PIN',
		label2: 'Confirm New PIN',
		buttonTitle: 'Reset PIN',
		successMessage: 'PIN Reset is successful',
	},
};
